import { render, staticRenderFns } from "./OpportunitySubServices.vue?vue&type=template&id=3b577235&scoped=true&"
import script from "./OpportunitySubServices.vue?vue&type=script&lang=js&"
export * from "./OpportunitySubServices.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitySubServices.vue?vue&type=style&index=0&id=3b577235&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b577235",
  null
  
)

export default component.exports